module.exports = __webpack_public_path__ + "static/media/Программа УОМШ-2023.418dd0b0.pdf";